/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
// import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import dayjs from "dayjs"
import { Key, useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import AnzenKanriSearchModal from "../../../components/SearchModal/AnzenKanriSearchModal"
import CONSTANT from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import AnzenKanriService from "../../../service/driver/anzenKanri/anzenKanriService"
import {
  TAnzenKanriGetRes,
  TAnzenKanriPostReq,
  TAnzenKanriPutReq,
  TAnzenKanriZissiReq,
  T安全管理,
} from "../../../service/driver/anzenKanri/TAnzenKanri"
import { TZyomuinListItem } from "../../../service/driver/TZyomuin"
import ZyomuinService from "../../../service/driver/zyomuinService"
import BusyoService from "../../../service/master/busyo/busyoService"

import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import dateUtil from "../../../ts/util/dateUtil"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"

import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import commonUtil from "../../../ts/util/commonUtil"
import stringUtil from "../../../ts/util/stringUtil"
import EmptyTextHeader from "../../../components/FlexGridWrapper/EmptyTextHeader"
import lodash from "lodash"
import _ from "lodash"

type TGridItem = TAnzenKanriZissiReq & {
  row_id: string
  社員氏名: string
  社員コード: string
}

const AnzenKanriRegister = () => {
  const [key, setKey] = useState<Key>()

  // 終了後の画面リロード用
  return <AnzenKanriRegisterInner setKey={setKey} key={key} />
}

/**
 * 安全会議登録
 * @returns
 */
const AnzenKanriRegisterInner: React.FC<{
  setKey: React.Dispatch<React.SetStateAction<Key | undefined>>
}> = ({ setKey }) => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const isNewMode = (id ?? 0) === 0
  const disPatch: AppDispatch = useDispatch()

  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  const [乗務員ItemSource, set乗務員ItemSource] = useState<TZyomuinListItem[]>()

  // 表示項目のstate
  const [会議No, set会議No] = useState<string>()
  const [部所コード, set部所コード] = useState<T部所マスタ["部所コード"]>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [実施日From, set実施日From] = useState<string | null | undefined>(
    dayjs(営業日).startOf("month").toISOString()
  )
  const [実施日To, set実施日To] = useState<string | null | undefined>(
    dayjs(営業日).endOf("month").toISOString()
  )
  const [会議名, set会議名] = useState<string>("")

  const [出席日, set出席日] = useState<string>(dateUtil.format(営業日))
  const [最終更新日時, set最終更新日時] = useState<string>("")
  const [更新対象元Resデータ, set更新対象元Resデータ] = useState<T安全管理>()

  // Grid用State
  const [flexGridFrom, setFlexGridFrom] = useState<wjGrid.FlexGrid>()
  const [flexGridTo, setFlexGridTo] = useState<wjGrid.FlexGrid>()

  const [gridDataFrom, setGridDataFrom] = useState<{
    data: wjCore.CollectionView<TGridItem>
  }>({ data: new wjCore.CollectionView<TGridItem>([]) })
  const [gridDataTo, setGridDataTo] = useState<{
    data: wjCore.CollectionView<TGridItem>
  }>({ data: new wjCore.CollectionView<TGridItem>([]) })

  const [isRestoreSearchingFrom, setIsRestoreSearchingFrom] =
    useState<boolean>(false)
  const [isRestoreSearchingTo, setIsRestoreSearchingTo] =
    useState<boolean>(false)

  const [gridInitializedFrom, setGridInitializedFrom] = useState<boolean>(false)
  const [gridInitializedTo, setGridInitializedTo] = useState<boolean>(false)

  // comboboxState

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  // init
  const [isDataLoaded, setIsDataLoaded] = useState(false)

  const [isComponentInit, setIsComponentInit] = useState(false)

  const [isAnzenKanriSelectModalShow, setIsAnzenKanriSelectModalShow] =
    useState(false)
  const [isConfirmNewModalShow, setIsConfirmNewModalShow] = useState(false)
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)

  //　エラー表示用フラグ
  const [isInvalid部所コード, setIsInvalid部所コード] = useState<boolean>(false)
  const [isInvalid会議名, setIsInvalid会議名] = useState<boolean>(false)
  const [isInvalid実施日From, setIsInvalid実施日From] = useState<boolean>(false)
  const [isInvalid実施日To, setIsInvalid実施日To] = useState<boolean>(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: number) => {
    const service = new AnzenKanriService()

    try {
      const res = await service.get(id)
      if (res.data) {
        set会議No(res.data.管理NO)
        set会議名(res.data.会議名)
        set部所コード(res.data.部所コード)
        set実施日From(res.data.実施日FROM)
        set実施日To(res.data.実施日TO)
        set最終更新日時(res.data.更新日時 ? res.data.更新日時 : "")

        set更新対象元Resデータ(res.data)
        // 出席日は出席者の持つ出席日の最大を設定
        let 出席日最後尾 = _.maxBy(res.data.実施情報List ?? [], (i) =>
          i?.実施日 != null ? dayjs(i?.実施日) : null
        )?.実施日
        if (出席日最後尾 != null) {
          set出席日(出席日最後尾)
        }
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let isError = false

    const エラーメッセージList: string[] = []

    // 必須チェック
    if (stringUtil.isNullOrWhiteSpace(部所コード)) {
      setIsInvalid部所コード(true)
      エラーメッセージList.push("部所は必須入力です")
      isError = true
    }
    if (stringUtil.isNullOrWhiteSpace(会議名)) {
      setIsInvalid会議名(true)
      エラーメッセージList.push("会議名は必須入力です")
      isError = true
    }
    if (stringUtil.isNullOrWhiteSpace(実施日From)) {
      setIsInvalid実施日From(true)
      エラーメッセージList.push("実施日Fromは必須入力です")
      isError = true
    }
    if (stringUtil.isNullOrWhiteSpace(実施日To)) {
      setIsInvalid実施日To(true)
      エラーメッセージList.push("実施日Toは必須入力です")
      isError = true
    }

    // 出席者チェック
    const has有効出席者データ = get実施情報ReqList().some(
      (r) => r.削除フラグ === 0
    )
    if (!has有効出席者データ) {
      エラーメッセージList.push("出席者を選択してください")
      isError = true
    }

    if (isError) {
      disPatch(setWarningAlerts(エラーメッセージList))
      return
    }

    setIsConfirmModalShow(true)
  }

  const clearError = () => {
    disPatch(clearAlert())
    setIsInvalid部所コード(false)
    setIsInvalid会議名(false)
    setIsInvalid実施日From(false)
    setIsInvalid実施日To(false)
  }

  const get実施情報ReqList = () => {
    const retList: TAnzenKanriZissiReq[] = []
    const fromSource: TGridItem[] = gridDataFrom.data.sourceCollection
    const toSource: TGridItem[] = gridDataTo.data.sourceCollection

    // from側から削除対象を抽出
    fromSource.forEach((item) => {
      if (item.乗務員安全管理実施ID != null)
        retList.push({
          乗務員安全管理実施ID: item.乗務員安全管理実施ID,
          乗務員ID: item.乗務員ID,
          実施日: item.実施日,
          削除フラグ: 1,
          更新日時: item.更新日時,
        })
    })

    toSource.forEach((item) => {
      if (item.乗務員安全管理実施ID == null) {
        if (item.削除フラグ === 0)
          retList.push({
            乗務員ID: item.乗務員ID,
            実施日: item.実施日,
            削除フラグ: 0,
          })
      } else {
        retList.push({
          乗務員安全管理実施ID: item.乗務員安全管理実施ID,
          乗務員ID: item.乗務員ID,
          実施日: item.実施日,
          削除フラグ: 0,
          更新日時: item.更新日時,
        })
      }
    })
    return retList
  }

  const getPostReq = (): TAnzenKanriPostReq => {
    return {
      部所コード: 部所コード ?? "",
      実施日From: 実施日From ?? "",
      実施日To: 実施日To ?? "",
      会議名: 会議名 ?? "",
      実施情報List: get実施情報ReqList(),
    }
  }

  const getPutReq = (): TAnzenKanriPutReq => {
    return {
      部所コード: 更新対象元Resデータ!.部所コード,
      実施日From: 実施日From ?? "",
      実施日To: 実施日To ?? "",
      会議名: 会議名 ?? "",
      実施情報List: get実施情報ReqList(),
      更新日時: 最終更新日時,
    }
  }

  /**
   * 削除
   */
  const deleteData = async () => {
    try {
      if (更新対象元Resデータ == null) return

      const service = new AnzenKanriService()
      const res = await service.deleteAnzenKanri(
        更新対象元Resデータ.乗務員安全管理ID,
        更新対象元Resデータ.更新日時
      )

      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        showInfoToast(
          `会議No:${更新対象元Resデータ.管理NO}の削除が完了しました`
        )

        //isPrompt対策
        //登録完了時表示を空っぽにしてリロード
        setTimeout(() => {
          const baseUrl = util.getMenuPath(
            メニューコード.乗務員管理.安全会議登録
          )[0]
          history.replace(baseUrl)
          setKey(new Date().toISOString())
        }, 10)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      setIsConfirmDeleteModalShow(false)
    }
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new AnzenKanriService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.putAnzenKanri(id, getPutReq())
      } else {
        res = await service.postAnzenKanri(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        // 削除か判定してメッセージ切り替え
        showInfoToast(
          id
            ? `会議No:${更新対象元Resデータ!.管理NO}の更新が完了しました`
            : `新規登録が完了しました`
        )

        //isPrompt対策
        //登録完了時表示を空っぽにしてリロード
        setTimeout(() => {
          const baseUrl = util.getMenuPath(
            メニューコード.乗務員管理.安全会議登録
          )[0]
          history.replace(baseUrl)
          setKey(new Date().toISOString())
        }, 10)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      setIsConfirmDeleteModalShow(false)
    }
  }

  /**
   * FromとToのCollectionView更新
   * @param 部所コード
   * @param 乗務員List
   * @param 更新対象元Resデータ
   */
  const updateCollectionView = (
    部所コード: string,
    乗務員List: TZyomuinListItem[],
    更新対象元Resデータ?: TAnzenKanriGetRes
  ) => {
    if (stringUtil.isNullOrWhiteSpace(部所コード)) {
      gridDataFrom.data.sourceCollection = []
      gridDataTo.data.sourceCollection = []
      return
    }

    // 部所に所属する乗務員をリストアップ
    const 部所乗務員List = 乗務員List.filter((z) => z.部所コード === 部所コード)

    let fromDataList: TGridItem[] = []
    let toDataList: TGridItem[] = []

    // 既存データがある場合
    if (更新対象元Resデータ != null) {
      const toData = 更新対象元Resデータ.実施情報List.map((item): TGridItem => {
        return {
          row_id: commonUtil.getUniqueStr(),
          乗務員ID: item.乗務員ID,
          乗務員安全管理実施ID: item.乗務員安全管理実施ID,
          社員コード: item.社員コード,
          社員氏名: item.社員氏名,
          実施日: item.実施日,
          更新日時: item.更新日時,
          削除フラグ: 0,
        }
      })
      toDataList = toData

      // toDataに存在しない乗務員をfromData側に作成
      const fromData = 部所乗務員List
        .filter(
          (z) => !toDataList.some((toItem) => toItem.乗務員ID === z.乗務員ID)
        )
        .map((z): TGridItem => {
          return {
            row_id: commonUtil.getUniqueStr(),
            乗務員ID: z.乗務員ID,
            社員コード: z.社員コード,
            社員氏名: z.社員氏名,
            削除フラグ: 0,
          }
        })
      fromDataList = fromData
    } else {
      // 部所乗務員をFrom側に設定
      const fromData = 部所乗務員List.map((z): TGridItem => {
        return {
          row_id: commonUtil.getUniqueStr(),
          乗務員ID: z.乗務員ID,
          社員コード: z.社員コード,
          社員氏名: z.社員氏名,
          削除フラグ: 0,
        }
      })
      fromDataList = fromData
    }

    const fromCv = new wjCore.CollectionView<TGridItem>(fromDataList)
    fromCv.filter = (item: TGridItem) => item.削除フラグ === 0

    const toCv = new wjCore.CollectionView<TGridItem>(toDataList)
    toCv.filter = (item: TGridItem) => item.削除フラグ === 0

    setGridDataFrom({ data: fromCv })
    setGridDataTo({ data: toCv })
  }

  const moveRight = (rightItem: TGridItem) => {
    const fromCv = gridDataFrom.data
    const fromDataList: TGridItem[] = fromCv.sourceCollection
    const fromData = fromDataList.find(
      (ti) => rightItem.乗務員ID === ti.乗務員ID
    )
    const toCv = gridDataTo.data
    // const toDataList: TGridItem[] = toCv.sourceCollection
    // const toData = toDataList.find((ti) => rightItem.乗務員ID === ti.乗務員ID)

    // FROM側処理
    if (fromData != null) fromCv.remove(fromData)

    // TO側処理
    toCv.beginUpdate()

    const newToData = toCv.addNew(fromData)
    newToData.実施日 = 出席日

    toCv.commitNew()
    toCv.endUpdate()

    fromCv?.refresh()
    toCv?.refresh()
  }

  const moveLeft = (leftItem: TGridItem) => {
    const fromCv = gridDataFrom.data
    // const fromDataList: TGridItem[] = fromCv.sourceCollection
    // const fromData = fromDataList.find(
    //   (ti) => leftItem.乗務員ID === ti.乗務員ID
    // )
    const toCv = gridDataTo.data
    const toDataList: TGridItem[] = toCv.sourceCollection
    const toData = toDataList.find((ti) => leftItem.乗務員ID === ti.乗務員ID)

    // TO側処理
    if (toData != null) toCv.remove(toData)

    // FROM側処理
    fromCv.beginUpdate()
    fromCv.addNew(toData)
    fromCv.commitNew()
    fromCv.endUpdate()

    fromCv.refresh()
    toCv.refresh()
  }

  //#endregion

  //#region [effect]

  // 初期データ読み込み
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    const abortController = new AbortController()

    Promise.all([
      new BusyoService().getList({}),
      // 退職以外全員取得
      new ZyomuinService().getList({ 退職フラグ: 0 }),
    ])
      .then(([部所ListRes, 乗務員ListRes]) => {
        const 運行部所List = 部所ListRes.data.filter(
          (b) => b.運行部所フラグ === 1
        )
        set部所ItemSource(運行部所List)
        set乗務員ItemSource(乗務員ListRes.data)

        setIsDataLoaded(true)
      })
      .catch((err) => {
        disPatch(setAlerts(err))
        disPatch(画面ロック解除())
      })

    return () => {
      abortController.abort()
    }
  }, [])

  // コンポーネント初期化
  useEffect(() => {
    // データロードが先
    if (!isDataLoaded) return

    // 各種コンポーネントの初期化確認
    if (!部所isLoadEnded) return

    // 初期化完了
    setIsComponentInit(true)
  }, [isDataLoaded, 部所isLoadEnded])

  // 編集データ読み込み
  useEffect(() => {
    if (!isDataLoaded) return
    if (!isComponentInit) return

    if (id) {
      // 既存データ編集
      getData(id)
        .finally(() => {
          setIsDataLoaded(true)
          disPatch(画面ロック解除())
          // ファイルロード後、戻るボタン押下時に警告が出るように変更
          isPrompt.current = true
        })
        .catch((err) => {
          disPatch(setAlerts(err))
        })
    } else {
      // 新規登録
      setIsDataLoaded(true)
      disPatch(画面ロック解除())
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    }
  }, [isDataLoaded, isComponentInit])

  // 部所切り替え時
  useEffect(() => {
    if (!isDataLoaded) return
    if (!isComponentInit) return
    if (!isNewMode && 更新対象元Resデータ == null) return

    updateCollectionView(
      部所コード ?? "",
      乗務員ItemSource ?? [],
      更新対象元Resデータ
    )
  }, [更新対象元Resデータ, 部所コード, isDataLoaded, isComponentInit])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">安全会議{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row className="search-button mb-2">
          <Col>
            <Button
              size="lg"
              type="button"
              disabled={isNewMode}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsConfirmNewModalShow(true)
              }}>
              新規登録
            </Button>
            <Button
              size="lg"
              className="ms-5"
              type="button"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsAnzenKanriSelectModalShow(true)
              }}>
              登録修正
            </Button>
            <Button
              size="lg"
              className="ms-5"
              type="button"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                const url = util.getMenuPath(
                  メニューコード.乗務員管理.安全会議実施一覧
                )[0]
                history.push(url)
              }}>
              安全会議実施一覧
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 登録カード */}
            <Card className="w-60rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 会議No */}
                  <MasterRegisterFormRow label="会議No" isRequired={true}>
                    <TextInput
                      id="会議No"
                      name="会議No"
                      isReadOnly={true}
                      value={会議No}
                      setValue={set会議No}
                    />
                  </MasterRegisterFormRow>
                  {/* 部所 */}
                  <MasterRegisterFormRow label="部所" isRequired={true}>
                    <ComboBox.Busyo
                      className={
                        isInvalid部所コード ? "w-20rem is-error" : "w-20rem"
                      }
                      autoFocus={true}
                      placeholder="部所"
                      isLoadEnded={部所isLoadEnded}
                      setIsLoadEnded={set部所isLoadEnded}
                      isUnselectStart={isNewMode}
                      isAllSelect={false}
                      isRequired={false}
                      isReadOnly={!isNewMode}
                      itemsSource={部所ItemSource}
                      selectedValue={部所コード}
                      setSelectedValue={(v) => {
                        set部所コード(v ?? undefined)
                      }}
                      ComboBox={部所ComboBox}
                      setComboBox={set部所ComboBox}></ComboBox.Busyo>
                  </MasterRegisterFormRow>
                  {/* 会議名 */}
                  <MasterRegisterFormRow label="会議名" isRequired={true}>
                    <TextInput
                      id="会議名"
                      name="会議名"
                      className={isInvalid会議名 ? "is-error" : ""}
                      value={会議名}
                      setValue={set会議名}></TextInput>
                  </MasterRegisterFormRow>
                  {/* 実施日 */}
                  <MasterRegisterFormRow label="実施日" isRequired={true}>
                    <div className="w-9-5rem">
                      <DateInput
                        id="実施日from"
                        placeholder="実施日From"
                        className={isInvalid実施日From ? "is-error" : ""}
                        isRequired={true}
                        value={実施日From}
                        defaultValue={営業日}
                        setValue={(v) => {
                          set実施日From(v)
                        }}></DateInput>
                    </div>
                    <div>
                      <span className="mx-2 align-middle fs-3"> ~ </span>
                    </div>
                    <div className="w-9-5rem">
                      <DateInput
                        id="実施日To"
                        placeholder="実施日To"
                        className={isInvalid実施日To ? "is-error" : ""}
                        value={実施日To}
                        isRequired={true}
                        defaultValue={営業日}
                        setValue={(v) => {
                          set実施日To(v)
                        }}></DateInput>
                    </div>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          {/* From(Left)FlexGrid */}
          <Col className="max-w-30rem  always-scrollbars">
            <FlexGridOuter
              flexGrid={flexGridFrom}
              setFlexGrid={setFlexGridFrom}
              gridConstantProperties={
                CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
              }
              gridData={gridDataFrom}
              setGridData={setGridDataFrom}
              style={{ height: "30rem" }}
              pageNumber={0}
              gridId={"AnzenKanriRegister_GridFrom"}
              isRestoreSearching={isRestoreSearchingFrom}
              setIsRestoreSearching={setIsRestoreSearchingFrom}
              gridInitialized={gridInitializedFrom}
              setGridInitialized={setGridInitializedFrom}
              pageSize={0}
              setPageSize={() => {}}
              headerComponent={
                <div
                  className="d-flex align-items-center"
                  style={{ height: "2.5rem" }}>
                  <label>出席日：</label>
                  <DateInput
                    id="出席日"
                    isRequired={true}
                    value={出席日}
                    defaultValue={営業日}
                    setValue={(v) => {
                      set出席日(v ?? 営業日)
                    }}></DateInput>
                </div>
              }
              isShowGridRowPickupButton={false}
              isShowGridFooter={false}>
              <wjrGrid.FlexGridColumn
                binding="社員コード"
                width={80}
                sortMemberPath="sort_社員コード"
                header="社員CD"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="社員氏名"
                width={128}
                header="氏名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="乗務員ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(context: TWijmoCellTemplateContext<TGridItem>) => (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        moveRight(context.item)
                      }}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
            </FlexGridOuter>
          </Col>
          {/* To(Right)FlexGrid */}
          <Col className="max-w-40rem always-scrollbars">
            <FlexGridOuter
              flexGrid={flexGridTo}
              setFlexGrid={setFlexGridTo}
              gridConstantProperties={
                CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
              }
              gridData={gridDataTo}
              setGridData={setGridDataTo}
              style={{ height: "30rem" }}
              pageNumber={0}
              gridId={"AnzenKanriRegister_GridTo"}
              isRestoreSearching={isRestoreSearchingTo}
              setIsRestoreSearching={setIsRestoreSearchingTo}
              gridInitialized={gridInitializedTo}
              setGridInitialized={setGridInitializedTo}
              pageSize={0}
              setPageSize={() => {}}
              headerComponent={
                <div
                  className="d-flex align-items-center"
                  style={{ height: "2.5rem" }}>
                  <label>出席者</label>
                </div>
              }
              isShowGridRowPickupButton={false}
              isShowGridFooter={false}>
              <wjrGrid.FlexGridColumn
                binding="社員コード"
                width={80}
                sortMemberPath="sort_社員コード"
                header="社員CD"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="社員氏名"
                width={128}
                header="氏名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="実施日"
                width={128}
                header="出席日">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(context: TWijmoCellTemplateContext<TGridItem>) => {
                    return dateUtil.format(context.item.実施日)
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="削除"
                align={"center"}
                binding="乗務員ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(context: TWijmoCellTemplateContext<TGridItem>) => (
                    <Button
                      variant="caution"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        moveLeft(context.item)
                      }}>
                      削除
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
            </FlexGridOuter>
          </Col>
        </Row>
        <Row className="search-button">
          <Col>
            <Button
              type="submit"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {id ? `更新` : `登録`}
            </Button>
            <Button
              className="ms-2"
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
            {id && (
              <Button
                className="ms-5"
                type="button"
                variant="caution"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIsConfirmDeleteModalShow(true)
                }}>
                削除
              </Button>
            )}
          </Col>
        </Row>
      </Container>
      {/* 新規登録 */}
      <ConfirmModal
        isShow={isConfirmNewModalShow}
        hideHandler={setIsConfirmNewModalShow}
        submitHandler={(e) => {
          e.stopPropagation()
          e.preventDefault()

          isPrompt.current = false
          setIsConfirmNewModalShow(false)

          // isPrompt.currentオフ対策
          setTimeout(() => {
            const url = util.getMenuPath(
              メニューコード.乗務員管理.安全会議登録
            )[0]
            history.replace(url)
          }, 10)
        }}>
        新規登録画面に遷移しますか？
      </ConfirmModal>
      {/* 登録更新 */}
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={(e) => {
          e.stopPropagation()
          e.preventDefault()
          submit()
        }}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      {/* 削除 */}
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={(e) => {
          e.stopPropagation()
          e.preventDefault()
          // 削除フラグとして引数1を渡す。
          deleteData()
        }}>
        <>会議No:{更新対象元Resデータ?.管理NO}を削除しますか？</>
      </ConfirmModal>
      <AnzenKanriSearchModal
        isShow={isAnzenKanriSelectModalShow}
        setIsShow={setIsAnzenKanriSelectModalShow}
        setItem={(selectedItem) => {
          isPrompt.current = false
          setIsAnzenKanriSelectModalShow(false)

          // isPrompt.currentオフ対策
          setTimeout(() => {
            const baseUrl = util.getMenuPath(
              メニューコード.乗務員管理.安全会議登録
            )[0]
            const newUrl = `${lodash.trimEnd(
              baseUrl,
              "/"
            )}/${selectedItem.乗務員安全管理ID.toString()}`

            const is新規登録画面から遷移 = history.location.pathname === baseUrl

            history.replace(newUrl)

            // 新規登録画面から遷移していない場合（id:3からid:4のような)
            if (!is新規登録画面から遷移) {
              // 同一パスと見られてコンポーネントが再作成されないため、強制リロード
              history.go(0)
            }
          }, 10)
        }}></AnzenKanriSearchModal>
    </>
  )
}

export default AnzenKanriRegister
